<template>
  <el-container>
    <el-header
        style="position: fixed; top: 0; left: 0; width: 100%; z-index: 10; background-color: white; border-bottom: 1px solid #dcdfe6;">
      <el-row align="middle" justify="end" style="height: 100%" type="flex">
        <el-col :span="2" style="line-height: 60px;">
          {{ user.name }}
        </el-col>
        <el-col v-if="user.roleId === 1" :span="3" style="height: 100%; padding: 14px 0;">
          <el-tag>企业管理员</el-tag>
        </el-col>
        <el-col :span="2" style="padding: 10px 0; height: 100%;">
          <el-image fit="contain" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" style="height: 100%"/>
        </el-col>
        <el-col :span="2" style="line-height: 60px;">
          <span @click="logout">退出登录</span>
        </el-col>
      </el-row>
    </el-header>
    <el-container style="margin-top: 60px">
      <el-aside width="200px">
        <el-menu
            ref="menu"
            :default-active="$route.path"
            style="border-right: none"
            @select="menuItemSelected">
          <el-menu-item index="/browser/home">
            <i class="el-icon-menu"></i>
            <span slot="title">首页管理</span>
          </el-menu-item>
          <el-menu-item index="/browser/organization-structure">
            <i class="el-icon-menu"></i>
            <span slot="title">组织架构</span>
          </el-menu-item>
          <el-menu-item index="/browser/employees">
            <i class="el-icon-document"></i>
            <span slot="title">人员管理</span>
          </el-menu-item>
          <el-menu-item index="/browser/issues">
            <i class="el-icon-setting"></i>
            <span slot="title">问题管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <router-view></router-view>
    </el-container>
  </el-container>
</template>

<script>
import axios from "axios";
import app from "@/App";
import qs from "qs";

export default {
  name: "Main",
  data() {
    return {
      user: {},
      issues: [],
      deadline: null,
      dialogVisible: false,
      page: 1,
      countOfAllIssues: 0,
      searchCriteria: {
        startOfDeadline: '',
        endOfDeadline: '',
      },
      activeIndex: '1',
      activeIndex2: '1'
    }
  },
  methods: {
    openLoginPage() {
      this.$router.replace({path: '/login'})
    },
    exportAsExcelButtonClicked() {
      this.dialogVisible = false;
      axios.post(app.url + '/issue/exportAsExcel', qs.stringify({
        searchStartDate: this.deadline ? this.deadline[0] : '',
        searchEndDate: this.deadline ? this.deadline[1] : '',
      })).then(response => {
        this.download(response.data.data);
      });
    },
    download(url) {
      let a = document.createElement('a');
      a.href = '/lfc/' + url;
      a.click();
    },
    deadlineChanged(deadline) {
      this.searchCriteria.startOfDeadline = deadline ? deadline[0] : '';
      this.searchCriteria.endOfDeadline = deadline ? deadline[1] : '';
      this.searchCriteriaChanged();
    },
    logout() {
      localStorage.removeItem('user');
      this.openLoginPage();
    },
    getProblems() {
      app.methods.getIssues({
        searchStartDate: this.searchCriteria.startOfDeadline,
        searchEndDate: this.searchCriteria.endOfDeadline,
        page: this.page,
        pageSize: 20
      }).then(response => {
        if (response.data.data.code !== "0") {
          // this.openLoginPage();
          return
        }
        this.issues = response.data.list
        this.countOfAllIssues = response.data.total
      });
    },
    pageChanged(page) {
      this.page = page;
      this.getProblems();
    },
    searchCriteriaChanged() {
      this.page = 1;
      this.getProblems();
      app.methods.getCountOfAllIssues(count => {
        this.countOfAllIssues = count;
      })
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    menuItemSelected(key) {
      this.$router.replace({path: key});
    },
  },
  created() {
    app.methods.getUser().then(res => {
      this.user = res.data;
      // this.searchCriteriaChanged();
    })
  },
}
</script>

<style scoped>

</style>
